module.exports = __webpack_public_path__ + "41af2f085f4ebbe40609cdb112ee31b8.pdf";